import type { WorkflowScheduledRun } from 'globals.gen';

export function mapScheduleRunTitle(run: WorkflowScheduledRun): string {
  return `Every ${run.every} ${run.period}${run.at ? `, At ${run.at}` : ''}`;
}
